import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {scrollToggleFixed} from "../../utils/scrollFixedNav";

document.addEventListener('DOMContentLoaded', function ()
{

    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#hero',
    });


    const swiperPorque = new Swiper('.swiper-porque', {
        loop: true,
        slidesPerView: 1,
/*        autoplay: true,
        speed: 1500,*/
        navigation: {
            prevEl: '.swiper-button-prev-porque',
            nextEl: '.swiper-button-next-porque',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
        },
    });

});
